import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';

@Component({
  selector: 'app-sort',
  templateUrl: './sort.component.pug',
  styleUrls: ['./sort.component.scss'],
  standalone: false
})
export class SortComponent implements OnInit {
  @Input() options: any[] = [];
  @Input() sortBy = '';
  @Output() sortChange = new EventEmitter();
  get sortOrderList() {
    return [$localize`Oldest`, $localize`Newest`];
  }
  get sortOrderFrequency(){
      return [$localize`Lowest`, $localize`Highest`]
  }

  sortOrdersNumber={
    "Ascending":"",
    "Descending":"-"
  }
  sortOrdersWord={
      "A-Z":"",
      "Z-A":"-"
  }
  sortOrdersFre={
      "Lowest":"",
      "Highest":"-"
  }
  sortOrdersGrouped={
    "Grouped at top":"",
    "Grouped at bottom":"-"
  }
  selectedOrder = '';
  sortString:any[] = []
  requestTemplate = false;
  constructor(private permissions: PermissionsService) {
    this.requestTemplate = this.permissions.isFeatureActivated('ent-10605-request-templates');
  }

  ngOnInit(): void {
    let selectedOption = {};
    let index = 0;
    let order = false; // False for descending
    if (this.sortBy !== ''){
      index = this.options.findIndex((option)=>
        this.sortBy.replace('-', '') === option['value']
      );
      index = index == -1 ? 0 : index;
      order = !this.sortBy.includes('-');
    }
    selectedOption = this.options[index];
    this.sortBy = selectedOption['label'];
    if (selectedOption['type']=="word"){
      this.selectedOrder = order ? "Z-A" : "A-Z";
    } else if (this.requestTemplate && selectedOption['type']=="frequency"){
      this.selectedOrder = order ? $localize`Highest` : $localize`Lowest`;
    }
    else{
      this.selectedOrder = order ? "Ascending" : "Descending";
    }
  }

  onSelectCol(col, value, dir){
    dir = this.localizeToDirection(dir);
    this.sortBy = col;
    this.selectedOrder = dir;
    let firstElement = this.sortOrdersNumber[dir]+value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(this.sortOrdersNumber[dir]+value);
  }

  localizeToDirection(dir: string): string {
    if (dir === $localize`Oldest`) {
      return "Ascending";
    } else if (dir === $localize`Newest`) {
      return "Descending";
    }
    return dir;
  }

  onSelectColWord(col, value, dir){
    this.sortBy = col;
    this.selectedOrder = dir;
    let firstElement = this.sortOrdersWord[dir]+value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(this.sortOrdersWord[dir]+value);
  }

  onSelectColFre(col, value, dir){
    this.sortBy = col;
    this.selectedOrder = dir;
    let firstElement = this.sortOrdersFre[dir]+value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(this.sortOrdersFre[dir]+value);
  }

  onSelectColGrouped(col, value, dir){
    this.sortBy = col;
    this.selectedOrder = dir;
    let firstElement = this.sortOrdersGrouped[dir]+value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(this.sortOrdersGrouped[dir]+value);
  }

  getColor(label, order){
    if (this.sortBy === label && this.selectedOrder === order){
      return '#32735F';
    }
    return '#000';
  }

}
